import { Component, OnInit, Output, ElementRef, HostListener, ViewChild, ViewContainerRef, EventEmitter, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { User, AppState, AuthService, CtMenuComponent, FullscreenService } from 'components';
import { Store } from '@ngrx/store'
import { Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  animations: [
    trigger('fadeInOut', [
      state('void', style({
        opacity: 0
      })),
      transition('void <=> *', animate(500)),
    ]),
  ]
})

export class HomeComponent implements AfterViewInit  {

  public loggedUser: User;
  public readonly CurrentYear: number = new Date().getFullYear();
  @ViewChild('ctmenu') ctMenu: CtMenuComponent;
  public isFullScreen: boolean = false;
  public ctMenuAvailable: boolean = false;
  public socialMediaVisiable : boolean = false;

  constructor(private loggedUserStore: Store<AppState>, 
    private el: ElementRef,
    private fullScreenService: FullscreenService,
    private cdr: ChangeDetectorRef) {
    this.subscribeToLoggedUserStore();
  }
  
  /**
   * sets the `ctMenuAvailable` flag when the `ctMenu` reference is available.
   * It also subscribes to the `showFullscreen$` observable from the `FullscreenService` and triggers change detection.
   */
  ngAfterViewInit(): void {
    this.ctMenuAvailable = !!this.ctMenu;
    this.subscribeToFullScreenService();
    this.cdr.detectChanges();
  }

  private subscribeToLoggedUserStore(): void {
    this.loggedUserStore.select(store => store).subscribe((state: any) => {
      this.loggedUser = state?.loggedUser?.user;
    });
  }

  /**
   * subscribes to the `showFullscreen$` observable from the `FullscreenService`.
   * It sets the `ctMenuAvailable` flag and updates the `isFullScreen` property.
   */
  private subscribeToFullScreenService(): void {
    this.fullScreenService.showFullscreen$.subscribe(value => {
      this.ctMenuAvailable = !!this.ctMenu;
      this.isFullScreen = value;
    });
  }

  onMenuHomeClick() {
    if(this.ctMenu.getIsOpen() == true){
      this.ctMenu.hideMenu();
    }else{
      this.ctMenu.showMenu();
    }
  }

  onShadowClick() {
    if(this.ctMenu.getIsOpen() == true){
      this.ctMenu.hideMenu();
    }
  }

  public toggleSsmnContacts() : void {
    this.socialMediaVisiable = !this.socialMediaVisiable;
  }

}
 
